import { render, staticRenderFns } from "./examCenter.vue?vue&type=template&id=3fc52d28&scoped=true&"
import script from "./examCenter.vue?vue&type=script&lang=js&"
export * from "./examCenter.vue?vue&type=script&lang=js&"
import style0 from "./examCenter.vue?vue&type=style&index=0&id=3fc52d28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc52d28",
  null
  
)

export default component.exports